/* Add localstorage and 10,150,200 to Pagination may 29,2022 */
/* Add 	offset=0 to m_PgSize  May 27,2023 */
/* Add Filter Result Oct 10, 2023 */
/* Remove calling p_getData for Front end Pagination Sep 11, 2024 */
<template lang="pug">
	div(class="kt-pagination")
		div()
			b-dropdown(variant="outline-secondary" :lazy="true"  dropup :text="p_prntRef.dp.limit.toString()" )
				b-dd-item(v-for="x in [5,10,25,50,100,150,200,250,500,1000]" :key="x" 
				:active="x==p_prntRef.dp.limit" @click="m_chgPgSize(x)") {{x}}
			|  {{p_isCard? 'cards' : 'rows'}} per page
		div()
			span Total:
				b {{p_prntRef.da.totalCountNotFiltered}}
			span(v-if="p_prntRef.dp.search") Search Result:
				b {{p_prntRef.da.totalCountFiltered}}
			span(v-if="p_prntRef.filtered") Filter Result:
				b {{p_prntRef.filtered}}
		div(v-if="c_pages.length>1")
			a(href="#" @click="m_prevPg")
				fa-icon(icon="chevron-left")
			a(href="#" @click="m_chgPg($event, x.offset)" 
				v-for="x in c_pages" :key="x.pg" v-show="!m_isHidden(x.pg)"
				:class="x.isactive ? 'active': null") {{x.pg}}
			a(href="#"  @click="m_nextPg")
				fa-icon(icon="chevron-right")
</template>

 <script>
export default {
	name: "kt-pagination",
	components: {},
	created() {
	},
	mounted() {
	if(window.localStorage.getItem(window.location.href+'-pageSize'))
	this.p_prntRef.dp.limit=parseInt(window.localStorage.getItem(window.location.href+'-pageSize'));
	},
	data() {
		return {};
	},
	props: {
		p_prntRef: Object,
		p_getData: Function,
		p_isCard: Boolean,
	},
	computed: {
		c_pages() {
			let dp = this.p_prntRef.dp;
			let tcf = this.p_prntRef.da.totalCountFiltered;

			let ttl = tcf / dp.limit;
			let pgs = [];
			let i;
			for (i = 0; i < ttl; i++) {
				let pgObj = {
					pg: i + 1,
					offset: i * dp.limit,
					isactive: (i * dp.limit) == dp.offset
				};
				pgs.push(pgObj);
			}
			return pgs;
		},
	},
	methods: {
		m_isHidden(pg) {
			let cp = this.c_pages.filter(x => x.isactive)[0].pg;
			let cpDiff = cp < 3 ? 3 : cp;
			let ttl = this.c_pages.length;
			if ((ttl - cp) < 3) cpDiff = ttl - 3;
			return Math.abs(pg - cpDiff) > 3;
		},
		m_chgPgSize(limit) {
			this.p_prntRef.dp.limit = limit;
			window.localStorage.setItem(window.location.href+'-pageSize',limit.toString());
			this.p_prntRef.dp.offset = 0;
			//this.p_getData();
		},
		m_prevPg(e) {
			e.preventDefault();
			let dp = this.p_prntRef.dp;
			if (dp.offset > 0) {
				dp.offset -= dp.limit;
				//this.p_getData();
			}
		},
		m_chgPg(e, offset) {
			e.preventDefault();
			this.p_prntRef.dp.offset = offset;
			//this.p_getData();
		},
		m_nextPg(e) {
			e.preventDefault();
			let dp = this.p_prntRef.dp;
			let tcf = this.p_prntRef.da.totalCountFiltered;
			if (tcf > 0 && dp.offset + dp.limit < tcf) {
				dp.offset += dp.limit;
				//this.p_getData();
			}
		}
	},
	watch: {}
};
</script>

<style lang="less">
.kt-pagination {
	// justify-content: space-between;
	display: flex;
	flex-wrap: wrap;
	padding: 0.5em 0em;
	border-top: solid 0.2em #dee2e6;
	font-size: 0.9em;
	// border: solid 0.1em red;
	> div {
		padding: 0.4em 0.2em;
		// border: solid 0.1em blue;
	}
	> div:nth-child(1) {
		.dropdown-toggle {
			font-size: 1em;
			padding: 0.1em 0.5em;
			border-radius: 0.2em;
			width: 40px;
		}
		.dropdown-menu {
			border-radius: unset;
			width: 50px;
			//overflow: auto;
            //max-height: 50px;
		}
	}
	> div:nth-child(2) {
		margin: auto 0.5em;
		> span:nth-child(2) {
			margin: auto 0.75em;
			font-size: 0.9em;
			//color: #adb5bd;
		}
	}
	> div:nth-child(3) {
		margin-left: auto;

		a {
			display: inline-block;
			padding: 0.2em 00em;
			text-align: center;

			border: solid 0.1em #e9ecef;
			width: 40px;
		}
		a:hover {
			background-color: #dee2e6;
		}
		a.active {
			color: #fff;
			background-color: #4fa4ff;
			font-weight: bolder;
			border-color: #4fa4ff;
		}
	}
}
</style>